import { render, staticRenderFns } from "./personal-details-modal.vue?vue&type=template&id=2aab5e40&scoped=true&"
import script from "./personal-details-modal.vue?vue&type=script&lang=js&"
export * from "./personal-details-modal.vue?vue&type=script&lang=js&"
import style0 from "./personal-details-modal.vue?vue&type=style&index=0&id=2aab5e40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab5e40",
  null
  
)

export default component.exports